// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import hearingAgendaItemEntity from './entities/hearing-agenda-item.json';
import hearingAgendaItemMenu from '../pages/hearing-agenda-item/menu.json';
import hearingAgendaItemFullForm from '../pages/hearing-agenda-item/forms/full.json';
import hearingAgendaItemContextForm from '../pages/hearing-agenda-item/forms/context.json';
import hearingAgendaItemMiniForm from '../pages/hearing-agenda-item/forms/mini.json';
import hearingAgendaItemLookupForm from '../pages/hearing-agenda-item/forms/lookup.json';
import hearingAgendaItemTableView from '../pages/hearing-agenda-item/views/table.json';
import hearingAgendaItemCardsView from '../pages/hearing-agenda-item/views/cards.json';
import hearingAgendaItemDashboardView from '../pages/hearing-agenda-item/views/dashboard.json';

/** Тип запису «Питання слухань» зі сторінками пакета: меню, форми та подання з pages/hearing-agenda-item/. */
export const hearingAgendaItemDefinition: IRecordTypeDefinition = {
  ...hearingAgendaItemEntity,
  views: assembleViewSet({
      table: hearingAgendaItemTableView,
      cards: hearingAgendaItemCardsView,
      dashboard: hearingAgendaItemDashboardView,
  }),
  form: hearingAgendaItemFullForm,
  forms: { full: hearingAgendaItemFullForm, context: hearingAgendaItemContextForm, mini: hearingAgendaItemMiniForm, lookup: hearingAgendaItemLookupForm },
  menu: hearingAgendaItemMenu,
} as IRecordTypeDefinition;
